module.exports = __webpack_public_path__ + "img/logo-d8.5a36c1f5.jpeg";